import Const from 'constants';
import {generateSignature} from 'helpers/hash';

const defaultState = {
    signature: null,
    running: false,
    getSignature() {
        return this.signature;
    },
    isRunning() {
        return this.running;
    },
};

export default function (state = defaultState, action) {
    state = {...state};

    if (action.type === Const.OPTIMIZATION_START) {
        state.signature = generateSignature();
        state.running = true;
    } else if (action.type === Const.OPTIMIZATION_TERMINATE) {
        state.running = false;
    } else if (action.type === Const.SET_STATUS_OF_LINEUPS_IS_FILLED) {
        if (state.isRunning() && action.data) {
            state.running = false;
        }
    }

    return state;
}
